export enum GameSessionResult {
  Won = 'won',
  Lost = 'lost',
}

export enum GameSessionReviewStatus {
  AwaitingApproval = 'awaiting_approval',
  Approved = 'approved',
  Rejected = 'rejected',
  Overridden = 'overridden',
}

export enum GameSessionStatus {
  Created = 'created',
  AwaitingPayment = 'awaiting_payment',
  Active = 'active',
  Completed = 'completed',
  Cancelled = 'cancelled',
  PaidOut = 'paid_out',
}
